import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QrcodeDialogComponent } from './qrcode-dialog/qrcode-dialog.component';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss']
})
export class QrcodeComponent implements OnInit {

  @Input() confidentialCode: String;
  qrcode:String;
  isMobile: boolean=false;
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
    this.qrcode = "https://www.colissimo.fr/entreprise/nad-bo/qrcode.htm?code=" + this.confidentialCode;
    if (window.outerWidth < 600) {
      this.isMobile = true;
    }
  }

  openConfidentialCode():void {
    this.dialog.open(QrcodeDialogComponent, {panelClass: 'qrcode-dialog', data:{"confidentialCode" :this.confidentialCode, "qrcode": this.qrcode}})
  }

}
